export const isDevEnv = process.env.NODE_ENV !== 'production'
export const isProdEnv = process.env.NODE_ENV === 'production'

console.log({ environment: process.env.NODE_ENV })
